module.exports = __webpack_public_path__ + "img/alert.4d618838.svg";